<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>添加品牌</span>
      </div>
      <el-form
        ref="addForm"
        :model="updateInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="100px"
      >
        <div class="add-form-item">
          <el-form-item label="品牌名称：" prop="name">
            <el-input v-model="updateInfo.name"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入20个字符</span>
        </div>

        <div class="add-form-item">
          <el-form-item label="品牌编码：" prop="code">
            <el-input v-model="updateInfo.code"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入20个字符</span>
        </div>

        <div class="add-form-item">
          <el-form-item label="跳转地址：" prop="url">
            <el-input v-model="updateInfo.url"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入400个字符</span>
        </div>

        <el-form-item>
          <el-button type="primary" @click="addInfo">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  data() {
    return {
      labelPosition: "left",
      updateInfo: {
        name: "",
        code: "",
        url: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入品牌名称",
            trigger: "blur"
          },
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入品牌编码"
          },
          {
            max: 20,
            message: "最多输入20个字符"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入品牌编码"
          },
          {
            max: 400,
            message: "最多输入400个字符"
          }
        ]
      }
    };
  },
  methods: {
    addInfo() {
      this.$refs.addForm.validate(isPass => {
        if (isPass) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.$router.go(-1);
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  components: {
    Breadcrumb
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
